/* The mockup's `.mcard`: a 10px card over a 16:10 thumbnail, name and star on one row, scope and day under. */
.card {
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: var(--surface-raised);
  border: 1px solid var(--border);
  border-radius: var(--radius-card);
  list-style: none;
  transition: border-color var(--motion-duration);
}

.card:hover {
  border-color: var(--border-strong);
}

.thumbnail {
  aspect-ratio: 16 / 10;
  border-block-end: 1px solid var(--border);
  background: var(--surface-sunken);
}

.body {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: var(--space-3);
}

.row {
  display: flex;
  align-items: center;
  gap: 2px;
}

.name {
  flex: 1;
  min-inline-size: 0;
  overflow: hidden;
  color: var(--text);
  font-weight: var(--font-weight-medium);
  text-decoration: none;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.name:hover {
  text-decoration: underline;
}

/* The stretched link: the whole card opens the mockup; the star and the menu sit above it. */
.name::after {
  content: "";
  position: absolute;
  inset: 0;
}

.name:focus-visible {
  outline: none;
}

.card:has(.name:focus-visible) {
  outline: 2px solid var(--focus-ring);
  outline-offset: 2px;
}

.meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  color: var(--text-subtle);
  font-size: var(--font-size-12);
}

.updated {
  font-variant-numeric: tabular-nums;
}

.srOnly {
  position: absolute;
  inline-size: 1px;
  block-size: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}
